import { AUTH_TOKEN } from '../../constants/localStorage.js';
import '../../constants/colors.js';

const storeAuthToken = (jwt) => {
    // TODO: update it to not use localStorage
    //        when we decide how to handle JWT https://linear.app/dynamic-labs/issue/DYN-178
    localStorage.setItem(AUTH_TOKEN, jwt);
};

export { storeAuthToken };
